import logoAjMonjos from 'assets/img/logo-redondo-aj-monjos.png'
import logoGestinet from 'assets/img/logo-gestinet-2048x950.png'
import Menu from 'components/layout/Menu/Menu'
import PropTypes from 'prop-types'
import { LuPanelLeftClose, LuPanelLeftOpen } from 'react-icons/lu'

export default function Sidebar({ isSidebarOpen, setIsSidebarOpen }) {
  return (
    <>
      {/* Barra lateral per a pantalles grans (tablets grans, portàtils, pantalles grans) */}
      <aside
        id="sidebar"
        className={`fixed top-0 left-0 z-20 h-screen font-normal transition-width duration-100 ${isSidebarOpen ? 'hidden md:flex md:flex-col md:flex-shrink-0 w-0 md:w-60' : 'hidden md:flex md:flex-col md:flex-shrink-0 w-0 md:w-20'}`}
        aria-label="Sidebar"
      >
        <div className="relative flex flex-col flex-1 min-h-0 bg-[#006F53] dark:bg-[#38393D]">
          <div
            className={`px-3 py-4 flex justify-between ${isSidebarOpen ? 'flex-row items-center' : 'flex-col items-start space-y-5'}`}
          >
            <div
              title="Ajuntament de Santa Margarida i els Monjos"
              className={`inline-flex pl-1 text-base text-white duration-75`}
            >
              <img
                className={`block float-left duration-500 bg-white rounded-full w-12 min-w-12 max-w-12 p-1 ${isSidebarOpen && 'rotate-[360deg]'}`}
                src={logoAjMonjos}
                alt="Ajuntament de Santa Margarida i els Monjos"
              />
            </div>

            {!isSidebarOpen ? (
              <div className="w-full pl-3">
                <LuPanelLeftOpen
                  title="Desplegar menú"
                  className={`text-white cursor-pointer hover:text-[#4a9e7e] duration-300`}
                  size={26}
                  onClick={() => setIsSidebarOpen((prev) => !prev)}
                />
              </div>
            ) : (
              <div className="w-auto">
                <LuPanelLeftClose
                  title="Plegar menú"
                  className={`text-white cursor-pointer hover:text-[#4a9e7e] duration-300`}
                  size={26}
                  onClick={() => setIsSidebarOpen((prev) => !prev)}
                />
              </div>
            )}
          </div>

          <ul
            id="scrollable-sidebar"
            className="pl-1.5 pr-2 py-3 space-y-2 overflow-y-auto overflow-x-hidden grow border-t-2 border-dashed border-[#4a9e7e] font-medium"
          >
            <Menu isSidebarOpen={isSidebarOpen} />
          </ul>

          {/* Footer amb el logo de Gestinet */}
          <div className="px-3 py-3">
            <a
              href="https://www.gestinet.com"
              target="_blank"
              rel="noopener noreferrer"
              title="Gestinet"
              className="flex justify-center"
            >
              <img
                className="object-contain duration-300"
                src={logoGestinet}
                loading="lazy"
                alt="Gestinet"
                style={{ maxHeight: isSidebarOpen ? '5rem' : '3.5rem', width: isSidebarOpen ? 'auto' : '4rem' }}
              />
            </a>
          </div>
        </div>
      </aside>

      {/* Barra lateral per a pantalles petites (mòbils, tablets petites) */}
      <aside
        id="sidebar"
        className={`fixed top-0 left-0 z-20 h-screen flex flex-col flex-shrink-0 font-normal transition-width duration-100 ${isSidebarOpen ? 'md:hidden w-9/12 sm:w-6/12 md:w-60' : 'w-0 overflow-hidden'}`}
        aria-label="Sidebar"
      >
        <div className="relative flex flex-col flex-1 min-h-0 px-3 py-4 bg-[#006F53]">
          <div
            className={`flex items-center justify-between duration-300 ${isSidebarOpen ? 'flex-row-reverse' : 'flex-col space-y-8 pt-2.5'}`}
          >
            {!isSidebarOpen ? (
              <LuPanelLeftOpen
                className={`text-white cursor-pointer hover:text-[#4a9e7e]`}
                size={30}
                onClick={() => setIsSidebarOpen((prev) => !prev)}
              />
            ) : (
              <LuPanelLeftClose
                className={`text-white cursor-pointer hover:text-[#4a9e7e]`}
                size={30}
                onClick={() => setIsSidebarOpen((prev) => !prev)}
              />
            )}

            <div className={`inline-flex pl-1 text-base text-white`}>
              <img
                className={`block float-left duration-500 bg-white rounded-full w-12 min-w-12 max-w-12 p-1 ${isSidebarOpen && 'rotate-[360deg]'}`}
                src={logoAjMonjos}
                loading="lazy"
                alt="Ajuntament de Santa Margarida i els Monjos"
              />
            </div>
          </div>

          <ul
            id="scrollable-sidebar"
            className="pt-4 pl-0.5 space-y-2 overflow-x-hidden overflow-y-auto grow font-medium"
          >
            <Menu isSidebarOpen={isSidebarOpen} />
          </ul>

          {/* Footer amb el logo de Gestinet */}
          {isSidebarOpen && (
            <div className="pt-3 mt-2">
              <a
                href="https://www.gestinet.com"
                target="_blank"
                rel="noopener noreferrer"
                title="Gestinet"
                className="flex justify-center"
              >
                <img
                  className="object-contain"
                  src={logoGestinet}
                  loading="lazy"
                  alt="Gestinet"
                  style={{ maxHeight: '5rem', width: 'auto' }}
                />
              </a>
            </div>
          )}
        </div>
      </aside>

      {/* Fons fosc per a pantalles petites quan el menú lateral és obert */}
      <div
        className={`${isSidebarOpen ? 'md:hidden' : 'hidden'} duration-1000 fixed z-10 w-screen h-screen bg-black bg-opacity-60`}
      ></div>
    </>
  )
}

Sidebar.propTypes = {
  isSidebarOpen: PropTypes.bool,
  setIsSidebarOpen: PropTypes.func
}
